import produce from 'immer'
import { createSelectionListViewContainer } from 'factories/SelectionListView'
import operatorActions from 'actions/operators'
import Component from 'components/DraftOrder/Items/FormView/SelectOperator'

export default createSelectionListViewContainer({
  extraDispatchToProps: (dispatch, props) => ({
    getItems: (params = {}) =>
      dispatch(operatorActions.getOptions({ active: 'Active', ...params })).then((r) =>
        produce(r, (draft) => {
          if (params.pageIndex <= 1 && !params.search) {
            draft.value.data.items.unshift({ id: 0, displayName: '' })
            draft.value.data.recordCount++
          }
        })
      ),
  }),
})(Component)
